import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { AuthSessionService } from './core/auth/auth-session.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: ` <router-outlet /> `
})
export class AppComponent {
  /** Starts idle timeout + proactive token refresh when authenticated. */
  private readonly _authSession = inject(AuthSessionService);
}

